import { defineMessages } from 'react-intl';

export default defineMessages({
  redirectText: {
    id: 'redirect.text',
    defaultMessage: 'Redirecting to login...',
  },
});
